import { Component, OnInit } from '@angular/core';
import {NewsService} from "../../services/news.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css']
})
export class ContentComponent implements OnInit {

  content:any=[{menu:''}];
  documentos:any=[];
  domain: string;
  constructor(private news: NewsService, private route: ActivatedRoute) {
    this.route.params.subscribe( params => {
      this.getContent(params.id);
    });
  }

  ngOnInit() {
    this.news.getNews().subscribe(response => {
        //this.noticias= response[0];
        this.documentos = response[1];
        console.log('=>', this.documentos);
        /*this.documentos.forEach((item, index) => {
          this.dg1.push({id:item.id,titulo:item.titulo,imagen:item.imagen});
        });*/
        console.log('DOCS',this.documentos);
        /*setTimeout(()=>{
          this.test();
          this.show='block';

        },500);*/


      },
      error => {
        console.log(<any>error);
      });
    this.news.getConfig().subscribe(response => {
        console.log('FILE_JSON', response);
        this.domain = response.back_domain;
      },
      error => {
        console.log(<any>error);
      });
  }
  getContent(id){
    this.news.getContent(id).subscribe(response => {

      this.content= response;
        console.log('CONTENT', response);


      },
      error => {
        console.log(<any>error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/content/content.component.ts